
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class TreeMakingGrid extends _Ext.GridBase<TreeMakingRow, any> {
        protected getColumnsKey() { return 'Production.TreeMaking'; }
        protected getDialogType() { return TreeMakingDialog; }
        protected getIdProperty() { return TreeMakingRow.idProperty; }
        protected getInsertPermission() { return TreeMakingRow.insertPermission; }
        protected getLocalTextPrefix() { return TreeMakingRow.localTextPrefix; }
        protected getService() { return TreeMakingService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date();
            var dt = now.getDay();
            var mt = now.getMonth();
            var yr = now.getUTCFullYear();
            var hr = now.getUTCHours();
            var mn = now.getUTCMinutes();
            var sc = now.getUTCSeconds();

            var voucherNo = FormatHelper.GetVoucherNo(75);
            var treeno = FormatHelper.GetFormats("Tree");

            this.editItem(<TreeMakingRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                CompanyId: Q.Authorization.userDefinition.CompanyId,
                FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                UserId: Q.Authorization.userDefinition.UserId,
                CurrencyId: Q.Authorization.userDefinition.CurrencyId,
                VoucherTypeId: 75,
                TreeNo: treeno,
                TransDate: now.toString()
            });
        }
    }
}